<template>
	<div class="card border-2 rounded-xl p-3 sm:p-4 lg:p-7">
		<slot></slot>
	</div>
</template>

<script setup></script>

<style lang="scss" scoped></style>
